import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { InputMain, NumericFormatCustom } from '../inputs';
import { FindError, FindSuccess } from '../../hooks';
import { AddModalButton } from '../buttons';
import {
    amazonActions,
    ebayActions,
    httpRequestsOnErrorsActions,
    httpRequestsOnSuccessActions,
    shopifyActions,
} from 'store';
import { Images } from 'assets/images';

export const PriceRules = ({ store, actionType, values, singleId, setupRequestParams }) => {
    const [open, setOpen] = useState(false);
    const {
        handleSubmit,
        control,
        reset,
    } = useForm();
    const dispatch = useDispatch();
    const success = FindSuccess(actionType);
    const beckError = FindError(actionType);

    useEffect(() => {
        if (values) {
            const setValues = {
                erplyPlistId: values?.erplyPlistId,
                percentIncrease: values?.percentIncrease,
                fixedIncrease: values?.fixedIncrease,
            };

            reset(setValues);
        }
    }, [values]);

    useEffect(() => {
        if (success?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(actionType));
            setOpen(false);
        }
    }, [success]);

    useEffect(() => {
        if (beckError?.error) {
            toast.error('Something went wrong');
        }

        return () => {
            dispatch(httpRequestsOnErrorsActions.removeError(actionType));
        }

    },[beckError])

    const handleEdit = (cancel) => {
        setOpen(prev => !prev);

        if (cancel && values) {
            const setValues = {
                erplyPlistId: values?.erplyPlistId,
                percentIncrease: values?.percentIncrease || '',
                fixedIncrease: values?.fixedIncrease || '',
            };

            reset(setValues);
        }
    };

    const onSubmit = (data) => {
        if (store === 'AMAZON') {
            dispatch(amazonActions.editAmazonPriceRules(data));
        }

        if (store === 'EBAY') {
            dispatch(ebayActions.editEbayPriceRules(data));
        }

        if (store === 'SHOPIFY') {
            dispatch(shopifyActions.editShopifyPriceRules(singleId, data, setupRequestParams));
        }
    };

    return (
        <div className='price-rules-wrapper'>
            <div className='price-rules-header'>
                <h2 className='price-rules-title'>
                    Price Rules
                </h2>

                {!open &&
                    <button onClick={handleEdit} className='edit-button'>
                        <img src={Images.Edit} alt='icon' />
                        <p>Edit</p>
                    </button>
                }

            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='flex' style={{ gap: 16 }}>
                    <InputMain
                        name='erplyPlistId'
                        label='Erply Price List ID'
                        control={control}
                        disabled={!open}
                    />

                    <NumericFormatCustom
                        name='percentIncrease'
                        label='Percentage of Price %'
                        control={control}
                        prefix='%'
                        disabled={!open}
                        isAllowed={(values) => {
                            const { floatValue } = values;
                            return floatValue === undefined || floatValue <= 100;
                        }}
                    />

                    <NumericFormatCustom
                        name='fixedIncrease'
                        label='Fixed Amount'
                        control={control}
                        prefix='$'
                        thousandSeparator={true}
                        disabled={!open}
                    />
                </div>

                {open &&
                    <div className='list-buttons-wrapper' style={{ maxWidth: 370, marginLeft: 'auto' }}>
                        <button
                            className='chancel-button'
                            onClick={() => handleEdit(true)}
                            type={'button'}
                        >
                            Cancel
                        </button>
                        <AddModalButton
                            text='Save'
                            type='submit'
                            load={actionType}
                        />
                    </div>
                }
            </form>
        </div>
    );
};

